"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.col.model': '模型',
    'dblogs.col.operation': '操作',
    'dblogs.col.recordId': '记录ID',
    'dblogs.col.date': '日期',
    'dblogs.col.payload': '数据',
    'dblogs.col.result': '结果',
};
